import React from 'react';
import styles from './ExchangeRate.module.css';

interface ExchangeRateProps {
  priceInGBP: number;
}

const ExchangeRate: React.FunctionComponent<ExchangeRateProps> = ({ priceInGBP }): JSX.Element => (
  <div className={styles.exchangeRate}>
    <div className={styles.exchangeRatePrice}>
      <span className={styles.exchangeRatePriceTitle}>Estimated Price in GBP</span>
      <span className={styles.exchangeRatePriceValue}>{`(£${priceInGBP.toFixed(2)} GBP)`}</span>
    </div>
    <p className={styles.exchangeRateDisclaimer}>
      Please note that the price in GBP is an estimate based on an average of exchange rates
      calculated from financial data providers and banks, including the European Central Bank.
      Exchange rates are pulled once daily and may vary. Your actual charge will be in US dollars
      and is subject to the foreign exchange rate at the time of your purchase and foreign
      transaction fees applied by your payment provider.
    </p>
  </div>
);

export default ExchangeRate;
